import React from 'react';
import {ReactNodeGenerator} from '../../../../../lib/helpers';
import {SelectQuestionPreview} from './parts/SelectQuestionPreview';
import {SelectQuestionTextArea} from './parts/SelectQuestionTextArea';
import {SelectSpecifications} from './parts/SelectSpecifications';
import {SelectQuestionEditStore} from './SelectQuestionEditStore';

export function* selectQuestionEditStoreRenderer(store: SelectQuestionEditStore): ReactNodeGenerator {
  yield (
    <div key="text-area" className="row">
      <div className="col">
        <div className="form-group">
          <SelectQuestionTextArea store={store}/>
        </div>
      </div>
    </div>);

  yield (<SelectSpecifications key="selects" store={store}/>);

  yield (<SelectQuestionPreview key="preview" store={store}/>);
}
